<app-menu class="mobile-only"></app-menu>
<div class="header-container sticky-mobile" routerLink="/">
  <h1 class="font-header">
    <span class="first-letter-uppercase">H</span>et <span class="first-letter-uppercase">R</span>aaymakers <span class="first-letter-uppercase">A</span>ntiek &amp; <span class="first-letter-uppercase">I</span>nterieur
  </h1>
  <span class="header-subtitle">17e - 19e EEUWSE ANTIQUITEITEN</span>


</div>

<hr/>

<app-menu class="desktop-only"></app-menu>
